import { SimpleDicItem, SimpleDictionary } from "tnx-shared";

// Loại biểu mẫu.
export enum TemplateTypes {
    word = 0,
    excel = 1,
    cxExcel = 2
}

export const dicTemplateType: SimpleDictionary = new SimpleDictionary([
    new SimpleDicItem(TemplateTypes.word, 'biểu mẫu word'),
    new SimpleDicItem(TemplateTypes.excel, 'biểu mẫu excel cũ'),
    new SimpleDicItem(TemplateTypes.cxExcel, 'biểu mẫu excel')
]);

export const dicTemplateAccept: SimpleDictionary = new SimpleDictionary([
    new SimpleDicItem(TemplateTypes.word, '.docx'),
    new SimpleDicItem(TemplateTypes.excel, '.xlsx'),
    new SimpleDicItem(TemplateTypes.cxExcel, '.xlsx')
]);

// Loại bookmarks.
export enum BookmarkTypes {
    String = 'String',
    DateTime = 'DateTime',
    Number = 'Number',
    Image = 'Image',
    HTML = 'HTML',
    Repeat = 'Repeat',
    Barcode = 'Barcode',
    QRCode = 'QRCode',
    Document = 'Document'
}

export const dicBookmarkType: SimpleDictionary = new SimpleDictionary([
    new SimpleDicItem(BookmarkTypes.String, 'String'),
    new SimpleDicItem(BookmarkTypes.DateTime, 'DateTime'),
    new SimpleDicItem(BookmarkTypes.Number, 'Number'),
    new SimpleDicItem(BookmarkTypes.Image, 'Image'),
    new SimpleDicItem(BookmarkTypes.HTML, 'HTML'),
    new SimpleDicItem(BookmarkTypes.Repeat, 'Repeat'),
    new SimpleDicItem(BookmarkTypes.Barcode, 'Barcode'),
    new SimpleDicItem(BookmarkTypes.QRCode, 'QR Code'),
    new SimpleDicItem(BookmarkTypes.Document, 'Document'),
]);

export const bookmarkTypeDatasource = dicBookmarkType.getDataSourceForDrop();

// Các phần của excel template.
export const excelPartTypes = {
    header: 1, // Cấu hình cell cho header
    body: 2, // Cấu hình cell cho body
    outside: 3
};

export const dicExcelPartType: SimpleDictionary = new SimpleDictionary([
    new SimpleDicItem(excelPartTypes.body, 'Body'),
    new SimpleDicItem(excelPartTypes.outside, 'Outside'),
    new SimpleDicItem(excelPartTypes.header, 'Header')
]);

export const excelPartTypeDataSource = dicExcelPartType.getDataSourceForDrop();
